/**
 * Window events the app dispatches to its own components: most make them
 * read the server again now, instead of on their next poll. One name each,
 * so a dispatch and its listeners cannot drift apart.
 *
 * public/sw.js is a plain script and cannot import these. It posts a
 * message to the page, and the page dispatches the event (swMessages.js).
 */

/** The viewer's own standing changed: a self-test was sent or confirmed,
 *  or they saved their name.
 *  MandatoryReachBanner reads GET /api/me again. */
export const ME_CHANGED_EVENT = 'ovr-me-changed';

/** The alerts may have changed: a push arrived, or an alarm was
 *  acknowledged or closed. FleetMapLayout's count poll and
 *  AlertHistoryPanel's list read again. */
export const ALERTS_CHANGED_EVENT = 'ovr-alerts-changed';

/** A mandatory page or a self-test notification was tapped while this
 *  window was open (sw.js posts OVR_OPEN_ALERTS). FleetMapLayout shows the
 *  alerts tab, on the cloud only. */
export const OPEN_ALERTS_EVENT = 'ovr-open-alerts';
